import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'; // Import the useLocation hook from react-router-dom
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'; // Import Leaflet CSS

export default function LocationMap() {
  const { state } = useLocation(); // Get state passed through the router (userEmail, shopId)
  const { userEmail, shopId } = state || {}; // Default to an empty object if state is not passed
  const [userLocation, setUserLocation] = useState(null);
  const [error, setError] = useState(null);

  // Fetch user location when the component mounts
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          console.log('User location fetched:', latitude, longitude);
          setUserLocation({ latitude, longitude });
        },
        (error) => {
          console.error('Error getting location:', error);
          setError('Unable to retrieve your location. Please try again.');
        }
      );
    } else {
      setError('Geolocation is not supported by this browser.');
    }
  }, []);

  const saveLocation = async () => {
    if (userLocation) {
      const { latitude, longitude } = userLocation;
 console.log(userEmail);
      try {
        // Send the location to the backend to save it in the database
        const response = await fetch('http://localhost:5000/api/save-location', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userEmail: userEmail, // Sending the email to identify the user    // Sending the shopId if needed
            latitude,
            longitude,
          }),
        });

        if (response.ok) {
          alert('Location saved successfully');
        } else {
          alert('Error saving location');
        }
      } catch (error) {
        console.error('Error saving location:', error);
        alert('Error saving location');
      }
    }
  };

  if (error) {
    return <div>{error}</div>;
  }

  if (!userLocation) {
    return <div>Loading your location...</div>;
  }

  const { latitude, longitude } = userLocation;

  return (
    <div>
      <h3>Your Location</h3>
      <MapContainer
        center={[latitude, longitude]}
        zoom={13}
        style={{ height: '400px', width: '100%' }}
      >
        {/* TileLayer for the map background */}
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {/* Marker for user location */}
        <Marker
          position={[latitude, longitude]}
          icon={new L.Icon({
            iconUrl: require('leaflet/dist/images/marker-icon.png'),
            iconSize: [25, 41],
            iconAnchor: [12, 41],
          })}
        >
          <Popup>
            <span>You are here!</span>
          </Popup>
        </Marker>
      </MapContainer>

      <button onClick={saveLocation} style={{ marginTop: '10px' }}>
        Save Location
      </button>
    </div>
  );
}
